import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ActionModal, DialogPosition } from '@ecdlink/ui';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDialog } from '../dialog/DialogService';
import { Dialog } from '@headlessui/react';
export const AppErrorHandler = (props) => {
    const history = useHistory();
    const dialog = useDialog();
    const onGraphQLError = (e) => {
        e.preventDefault();
        if (!props.suppressErrorPopup) {
            dialog({
                blocking: false,
                position: DialogPosition.Middle,
                color: 'bg-white',
                render: (onClose) => {
                    return (_jsx(Dialog.Panel, { children: _jsx(ActionModal, { iconColor: "alertMain", iconBorderColor: "errorBg", title: props.title || 'Eish! Something went wrong!', detailText: props.detailText || 'Please go back to the home page.', icon: 'ExclamationCircleIcon', actionButtons: [
                                {
                                    colour: 'primary',
                                    text: !!props.buttonText ? props.buttonText : 'Home',
                                    textColour: 'white',
                                    type: 'filled',
                                    leadingIcon: 'HomeIcon',
                                    onClick: () => {
                                        onClose();
                                        history.push(!!props.buttonRoute ? props.buttonRoute : '/');
                                    },
                                },
                                {
                                    colour: 'primary',
                                    text: 'Get Help',
                                    textColour: 'white',
                                    type: 'filled',
                                    leadingIcon: 'QuestionMarkCircleIcon',
                                    onClick: () => {
                                        onClose();
                                        history.push('/user-help');
                                    },
                                },
                            ] }) }));
                },
            });
        }
    };
    const onServerTimeOut = (e) => {
        e.preventDefault();
        dialog({
            blocking: false,
            position: DialogPosition.Middle,
            color: 'bg-white',
            render: (onClose) => {
                return (_jsx(Dialog.Panel, { children: _jsx(ActionModal, { iconColor: "alertMain", iconBorderColor: "errorBg", title: props.title || 'Eish! Something went wrong with your network!', detailText: props.detailText ||
                            'Please check your connection and try again.', icon: 'ExclamationCircleIcon', actionButtons: [
                            {
                                colour: 'primary',
                                text: !!props.buttonText ? props.buttonText : 'OK',
                                textColour: 'white',
                                type: 'filled',
                                leadingIcon: 'HomeIcon',
                                onClick: () => {
                                    onClose();
                                    history.push(!!props.buttonRoute ? props.buttonRoute : '/');
                                },
                            },
                            {
                                colour: 'primary',
                                text: 'Get Help',
                                textColour: 'white',
                                type: 'filled',
                                leadingIcon: 'QuestionMarkCircleIcon',
                                onClick: () => {
                                    onClose();
                                    history.push('/user-help');
                                },
                            },
                        ] }) }));
            },
        });
    };
    useEffect(() => {
        window.addEventListener('graphql-error', onGraphQLError, false);
        window.addEventListener('timeout-error', onServerTimeOut, false);
        return () => {
            window.removeEventListener('graphql-error', onGraphQLError);
            window.removeEventListener('timeout-error', onServerTimeOut);
        };
    }, []);
    return _jsx(_Fragment, { children: props.children });
};
//# sourceMappingURL=index.js.map